<div class="cr-page">

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="cr-loading" *ngIf="!ready">
    <div class="cr-loading__icon"><mat-icon>trending_up</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="cr-loading__text">Cargando formulario…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── HEADER ─────────────────────────────────────────────── -->
    <div class="cr-header">
      <div class="cr-header__icon"><mat-icon>trending_up</mat-icon></div>
      <div>
        <h1 class="cr-header__title">{{ creditos.uid ? 'Editar crédito' : 'Nuevo crédito a entidad' }}</h1>
        <p class="cr-header__sub">{{ creditos.uid ? 'Modifica los datos del crédito' : 'Registra un nuevo crédito a entidad' }}</p>
      </div>
      <button mat-flat-button class="cr-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

    <!-- ── BODY ───────────────────────────────────────────────── -->
    <div class="cr-body">
      <form onkeypress="return event.keyCode != 13;">
        <div class="cr-grid">

          <!-- COLUMNA IZQUIERDA -->
          <div class="cr-left">

            <!-- SECCIÓN: Identificación -->
            <div class="cr-section">
              <div class="cr-section__head">
                <mat-icon>perm_identity</mat-icon>
                <span>Identificación</span>
              </div>
              <div class="cr-section__body">

                <div class="cr-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Duración</mat-label>
                    <mat-select [(ngModel)]="creditos.duracion" name="duracion"
                      (selectionChange)="duracionChangeValue($event.value)" required
                      matTooltip="Selecciona una opción para cargar las cuentas correspondientes">
                      <mat-option [value]="1">Corto Plazo</mat-option>
                      <mat-option [value]="2">Largo Plazo</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <app-select [(ngModel)]="creditos.cuentaContableACrear" name="cuentaContableACrear"
                    [config]="{ label: 'Cuenta contable', required: true, loadOptions: () => cuentaContableOptions }">
                  </app-select>
                </div>

                <app-input inputType="text" placeholder="Descripción" [isRequired]="true"
                  [(ngModel)]="creditos.descripcion"></app-input>

              </div>
            </div>

            <!-- SECCIÓN: Plazos -->
            <div class="cr-section">
              <div class="cr-section__head">
                <mat-icon>date_range</mat-icon>
                <span>Plazos</span>
              </div>
              <div class="cr-section__body">

                <div class="cr-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de constitución</mat-label>
                    <input matInput [matDatepicker]="fechaConstitucion" name="creditos.fechaConstitucion"
                      [(ngModel)]="creditos.fechaConstitucion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaConstitucion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaConstitucion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Plazo (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="creditos.plazo" name="creditos.plazo" required>
                  </mat-form-field>
                </div>

                <div class="cr-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de finalización</mat-label>
                    <input matInput [matDatepicker]="fechaFinalizacion" name="creditos.fechaFinalizacion"
                      [(ngModel)]="creditos.fechaFinalizacion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaFinalizacion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaFinalizacion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Carencia (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="creditos.carencia" name="creditos.carencia" required>
                  </mat-form-field>
                </div>

              </div>
            </div>

          </div>

          <!-- COLUMNA DERECHA -->
          <div class="cr-right">

            <!-- SECCIÓN: Importes y condiciones -->
            <div class="cr-section">
              <div class="cr-section__head">
                <mat-icon>attach_money</mat-icon>
                <span>Importes y condiciones</span>
              </div>
              <div class="cr-section__body">

                <div class="cr-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe inicial</mat-label>
                    <input matInput type="text" [(ngModel)]="creditos.importeInicial"
                      name="creditos.importeInicial" numberDecimalsDirective required>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe pendiente</mat-label>
                    <input matInput type="text" [(ngModel)]="creditos.importePendiente"
                      name="creditos.importePendiente" numberDecimalsDirective required>
                  </mat-form-field>
                </div>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Tipo de interés</mat-label>
                  <input matInput type="text" [(ngModel)]="creditos.tipoInteres"
                    name="creditos.tipoInteres" numberDecimalsDirective required>
                </mat-form-field>

              </div>
            </div>

            <!-- SECCIÓN: Liquidaciones y cuenta -->
            <div class="cr-section">
              <div class="cr-section__head">
                <mat-icon>account_balance_wallet</mat-icon>
                <span>Liquidaciones y cuenta</span>
              </div>
              <div class="cr-section__body">

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Tipo de liquidaciones</mat-label>
                  <mat-select [(ngModel)]="creditos.tipoLiquidaciones" name="tipoLiquidaciones" required>
                    <mat-option [value]="0">Sin seleccionar</mat-option>
                    <mat-option [value]="1">Mensual</mat-option>
                    <mat-option [value]="2">Bimensual</mat-option>
                    <mat-option [value]="3">Trimestral</mat-option>
                    <mat-option [value]="4">Semestral</mat-option>
                    <mat-option [value]="5">Anual</mat-option>
                  </mat-select>
                </mat-form-field>

                <app-autocomplete-select [items]="bankAccounts"
                  [(selectedItemId)]="creditos.bankAccountsUid"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']"
                  placeholder="Cuenta de abono" class="w-100">
                </app-autocomplete-select>

              </div>
            </div>

          </div>

        </div>
      </form>
    </div>

  </ng-container>

</div>
